import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components Global
import Modal from '../../../../../../../components/Modals/Modal'
import FormValidation from '../../../../../../../components/FormValidation'
import Select from '../../../../../../../components/input/Select/index'
import CheckBox from '../../../../../../../components/input/CheckBox/index'
import BtnSubmit from '../../../../../../../components/button/BtnSubmit'

// Util
import getFormValue from '../../../../../../../util/getFormValue'

// Actions
import { updateOrder } from '../../../../../../../redux/Orders/OrdersActions'



class WhtEditModal extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.mounted = true
  }

  componentWillUnmount() {
    this.mounted = false
  }

  fnStartModal() {
    let order = this.props.order
    let checkBox = order.wht.status === true

    this.mounted && this.setState({ checkBox: checkBox }, () => {
      this.setState({ disabled: this.checkDisabled() })
    })
  }

  checkDisabled = () => {
    let order = this.props.order
    let checkBox = this.state.checkBox
    let disabled

    if (order.wht.status) {
      if (checkBox === undefined) disabled = false
      else if (checkBox === true) disabled = false
      else if (checkBox === false) disabled = true
    } else {
      if (checkBox === undefined) disabled = true
      else if (checkBox === true) disabled = false
      else if (checkBox === false) disabled = true
    }

    return disabled
  }

  handleSubmit = (e, formName) => {
    e.preventDefault()
    let params = getFormValue(this.refs[formName])

    if (params['wht.rate'] === '0') {
      params['wht.status'] = false
    }

    const { business, order } = this.props
    const query = {
      authName: 'admin',
      dbNo: business.dbNo,
      businesses_id: business._id,
      orders_id: order._id
    }

    this.props.dispatch(updateOrder(query, {
      body: params,
      loadId: 'whtEditModal',
      modalId: 'whtEditModal',
      toastMsg: 'แก้ไข หัก ณ ที่จ่าย แล้ว'
    })).then(res => {
      if (res.success && this.props.fetch) {
        this.props.fetch()
      }
    })
  }

  onChange = (value, id) => {
    this.mounted && this.setState({ checkBox: value, disabled: value === false })
  }

  render() {
    let order = this.props.order

    return (
      <Modal
        id="whtEditModal"
        headerTitle="หัก ณ ที่จ่าย"
        headerLeft
        fnStartModal={() => this.fnStartModal()}
        width="350px"
        padding="0px">

        <div className="pd-15">
          <FormValidation ref="whtEditModal" name="whtEditModal" submit={(e) => this.handleSubmit(e, 'whtEditModal')} >
            <table>
              <tbody>
                <tr>
                  <td className="pd-0" width="40">
                    <CheckBox
                      id={`wht.status`}
                      size="sm"
                      value={order.wht.status}
                      onChange={this.onChange}
                      className="mg-top-15"
                    />
                  </td>
                  <td className="pd-0">
                    <Select
                      active
                      disabled={this.state.disabled}
                      disabledValue="0"
                      disabledPlaceholder="0%"
                      id={`wht.rate`}
                      default
                      value={this.state.disabled ? '0' : order.wht.rate }
                      className="mg-bottom-0"
                      options={[
                        { value: '0', name: '0%' },
                        { value: '0.5', name: '0.5%' },
                        { value: '0.75', name: '0.75%' },
                        { value: '1', name: '1%' },
                        { value: '2', name: '2%' },
                        { value: '3', name: '3%' },
                        { value: '5', name: '5%' },
                        { value: '10', name: '10%' },
                        { value: '15', name: '15%' },
                      ]}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="pd-top-15 text-right">
              <BtnSubmit
                icon="send"
                iconAlign="left"
                text="บันทึก"
                className="waves-effect waves-light btn light-green darken-1"
                loadingId="whtEditModal"
                btnDisabled
              />
            </div>
          </FormValidation>
        </div>
      </Modal>
    )
  }
}

export default connect()(WhtEditModal)
